import { config } from "@/config";
import { useFlow } from "@frigade/react";
import * as Frigade from "@frigade/react";
import { OnboardingSteps } from "../OnboardingGuide";
import OnboardingFlow from "./OnboardingFlow";

const OnboardingReportsAnnouncementFlow = () => {
  const { flow } = useFlow(config.frigade.flows.gettingStarted);
  const { flow: reportsFlow } = useFlow(config.frigade.flows.reportsViewHint);
  const currentStep = flow?.getCurrentStep();

  if (
    !reportsFlow?.isCompleted &&
    (currentStep?.id as OnboardingSteps) === "publish_feedback"
  ) {
    console.log("Reports flow is not completed");
    return (
      <OnboardingFlow>
        <Frigade.Announcement
          flowId={config.frigade.flows.reportsViewHint}
          defaultOpen={true}
          alignOffset={19}
        />
      </OnboardingFlow>
    );
  }
};

export default OnboardingReportsAnnouncementFlow;
